import { IconTitleDescButton } from 'shared/ui/onBoarding';
import { ReactComponent as SuccessIcon } from 'styles/images/icon_success.svg';

export const ServiceCancelSuccess = () => {
  return (
    <>
      <IconTitleDescButton
        title={<>케어노트 이용을 해지했어요</>}
        desc={
          <>
            케어노트 서비스는
            <br />
            언제든 다시 이용할 수 있어요.
          </>
        }
        icon={<SuccessIcon />}
        buttons={[
          {
            label: '닫기',
            variant: 'secondary',
            onClick: () => {
              if (/android/i.test(navigator.userAgent)) {
                window.location.href = 'kakaotalk://inappbrowser/close';
              }

              if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                window.location.href = 'kakaotalk://web/close';
              }
            },
          },
        ]}
      />
    </>
  );
};
